<!-- breadcrumb -->
     <div class="container marginMobile">
       <div class="col-sm-12 breadcrumb py-3 m-0">
         <!-- <a href="#">Produits</a>&nbsp;>&nbsp;<a href="#">Sanitaire</a>&nbsp;>&nbsp;Accessoires de salle de bain et wc -->
       </div>
     </div>
     <!-- Fin breadcrumb -->
     <div class="container">
     <!-- sideBar -->
     <div class="row">
       <div class="col-sm-3 sideFiltre">
         <button class="btn btn-primary titreSideBar catcolappse" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecategories" aria-expanded="false" aria-controls="collapseExample">
             Catégorie <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
           </button>
         <div class="collapse show" id="collapsecategories" >
           <div class="F3content">
             <div class="f3" id="accordionExample">
                 <div class="accordion-item" *ngFor="let f1 of listF1;let index = index;">
                   <h2 class="accordion-header" id="headingOne">
                     <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#sanitairecord-{{index}}" aria-expanded="true" aria-controls="collapseOne">
                       {{f1?.titre}}
                     </button>
                   </h2>
                   <div id="sanitairecord-{{index}}" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                     <div class="accordion-body">
                       <div class="list-group">
                         <ng-container *ngFor="let f2 of listF2">
                           <a href="#" class="list-group-item list-group-item-action"  *ngIf="f2.parent == f1.id" >{{f2?.titre}}</a>
                         </ng-container>

                       </div>
                     </div>
                   </div>
                 </div>
               </div>
           </div>
         </div>
         <button class="btn btn-primary titreSideBar subcatcollapse" type="button" data-bs-toggle="collapse" data-bs-target="#subCat" aria-expanded="false" aria-controls="collapseExample">
             Sous-catégorie <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
           </button>
         <div class="collapse show" id="subCat">
           <div class="f3">
             <div class="list-group">
               <a [routerLink]="['products/',f3.id]" *ngFor="let f3 of listF3" class="list-group-item list-group-item-action">{{f3.titre}}</a>
               <!-- <a href="#" class="list-group-item list-group-item-action">Porte brosse wc</a>
               <a href="#" class="list-group-item list-group-item-action">Porte manteau</a>
               <a href="#" class="list-group-item list-group-item-action">Porte papier</a>
               <a href="#" class="list-group-item list-group-item-action">Porte savon</a>
               <a href="#" class="list-group-item list-group-item-action">Porte serviettes</a>
               <a href="#" class="list-group-item list-group-item-action">Poubelle</a> -->
             </div>
           </div>
         </div>
         <button class="btn btn-primary titreSideBar brandcollapse" type="button" data-bs-toggle="collapse" data-bs-target="#fournisseur" aria-expanded="false" aria-controls="collapseExample">
             Fournisseur <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
           </button>
         <div class="collapse show" id="fournisseur">
           <div class="f3">
             <div class="list-group">
              <a  *ngFor="let fournisseur of fournisseurs" class="list-group-item list-group-item-action" [routerLink]="['/marque/',fournisseur.TSICOD4]">
                  {{ fournisseur.SEAKEY}}
              </a>
             </div>
           </div>
         </div>
       </div>
       <div class="col-sm-9">
         <div class="container">
           <div class="row">
             <div class="col-sm-12 triProducts mb-4 d-none ">
               Filtrez Par Prix De :
               <input type="number" (ngModel)="prixMin" class="triPrix" placeholder="30">
               Dhs à
               <input type="number" (ngModel)="prixMax" class="triPrix" placeholder="300"> Dhs
               <button type="button" (click)="filtrePrix()" name="button" class="btn triReset "><i class="fa fa-times" aria-hidden="true"></i>
Réinitialiser</button>

             </div>
             <!-- filtre show products -->
             <div class="col-sm-12 triProducts mb-4 text-end">
               <div class="triAffichage">
                 Affichage :
                 <select class="form-select selectAffichage" (change)="changeMax($event.target.value)" aria-label="Default select example">
                   <option value="12">x 12 Produits</option>
                   <option value="22">x 22 Produits</option>
                   <option value="44">x 44 Produits</option>
                   <option value="88">x 88 Produits</option>
                 </select>
               </div>
             </div>
             <!-- list products -->
             <div class="col-sm-4" *ngFor="let product of productByCategory | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: total }">
               <div class="newProductContainer">
                 <a [routerLink]="['/product-details/',product.ITMREF]" class="ProductImgContainer">
                   <img  src="{{baseUrl}}/{{product.VIG}}" class="img-fluid ProductImg" />
                 </a>
                 <div class="productData">
                   <div class="productIcons text-center">
                     <!-- <a href="#" class="likeAction productActions">
                       <span class="fa-stack fa-lg">
                         <i class="fa fa-circle fa-stack-2x"></i>
                         <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                       </span>
                     </a> -->
                     <a [routerLink]="['/product-details/',product.ITMREF]" class="viewAction productActions">
                       <span class="fa-stack fa-lg">
                         <i class="fa fa-circle fa-stack-2x"></i>
                         <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                       </span>
                     </a>
                     <!-- <a href="#" class="addtocartAction productActions">
                       <div class="viewAction">
                         <span class="fa-stack fa-lg">
                           <i class="fa fa-circle fa-stack-2x"></i>
                           <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                         </span>
                       </div>
                     </a> -->
                   </div>
                   <a [routerLink]="['/product-details/',product.ITMREF]" class="productDetails">
                     <div class="productTitle text-center">
                       {{product.ITMDES1}}
                     </div>
                     <div class="productPrice text-center">
                       <strong>{{product.PRIXNET}}</strong> MAD
                     </div>
                   </a>
                 </div>
               </div>
             </div>

             <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center">
                <li class="page-item"><a class="page-link" (click)="previousPage()">Previous</a></li>
                <li class="page-item" *ngFor="let pageNumber of pageNumbers" [class.active]="pageNumber == startIndex" (click)="goToPage(pageNumber)">
                  <a class="page-link">{{ pageNumber }}</a>
                </li>
                <li class="page-item"><a class="page-link" (click)="nextPage()">Next</a></li>
              </ul>
            </nav>

           </div>
         </div>
       </div>
     </div>
     <!-- Fin sideBar -->
     </div>
